/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Card_DetailsInputs */



/**
* | output |
* | --- |
* | "New Card Details" |
*
* @param {New_Card_DetailsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_card_details = /** @type {((inputs?: New_Card_DetailsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Card_DetailsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Détails de la nouvelle carte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Kartendetails")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovi dettagli della carta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новые данные карты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevos detalles de la tarjeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新卡详情")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいカードの詳細")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नए कार्ड का विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novos detalhes do cartão")
	return /** @type {LocalizedString} */ ("New Card Details")
});